<modal #dialog class="new-dialog dialog-no-overlay promotion-overlay-dialog" [overscrollFix]="'always'" data-crlat="d.promoOver">
    <ng-template #modalHeader>
        <div data-crlat="header">
            <a class="dialog-close" (click)="closeDialog()" data-crlat="closeButton"> </a>
            <span data-crlat="title">{{ promo?.title }}</span>
        </div>
    </ng-template>
    <ng-template #modalBody>
        @if (promo) {
            <div class="container" data-crlat="details">
                <div class="text-center">
                    @if (promo.uriMedium) {
                        <img [attr.src]="promo.uriMedium" class="promotion-overlay-img" data-crlat="image" />
                    }
                </div>
                @if (promo.shortDescription) {
                    <div class="promotion-overlay-short-description" data-crlat="shortDescription">
                        {{ promo.shortDescription }}
                    </div>
                }
                <div class="promotion-overlay-inner">
                    @if (promoDescription) {
                        <div class="promotion-overlay-description" [innerHTML]="promoDescription" data-crlat="promoDescription"></div>
                    }
                    <div class="clearfix">
                        <a
                            class="btn btn-style1 dialog-btn"
                            [i18n]="'promotions.betNow'"
                            (click)="!promo.overlayBetNowUrl && closeDialog()"
                            [routerLink]="promo.overlayBetNowUrl"
                            data-crlat="betNow">
                        </a>
                    </div>
                    <accordion class="promotion-overlay-tc" [render]="true" [isExpanded]="true" [pcTextBlock]="true">
                        <left-side>
                            <span class="left-title-text" [i18n]="'promotions.termsAndConditionsLabel'" data-crlat="headerTitle.leftMessage"></span>
                        </left-side>
                        <accordion-body>
                            <div [innerHTML]="promoHtmlMarkup"></div>
                        </accordion-body>
                    </accordion>
                </div>
            </div>
        }
        @if (loaded && !promo) {
            <div class="item-inner text-center">
                <strong [i18n]="'promotions.noPromo'" data-crlat="noPromo"></strong>
            </div>
        }
    </ng-template>
</modal>
